import React, { useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import bcrypt from 'bcryptjs';
import Navbar from './Navbar';
import Info from '../assets/images/info-circle.png';
import Fire from '../assets/images/fire.png';
import BGPlanet from '../assets/images/bg-plant.png';
import { toast } from 'react-toastify';

const Home = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const navigate = useNavigate();
    const fileInputRef = useRef();

    const handleFileChange = async (event) => {
        event.preventDefault();
        const file = event.target.files?.[0] || event.dataTransfer?.files?.[0];
        if (!file) {
            alert('لطفا یک تصویر انتخاب کنید');
            return;
        }
        setSelectedFile(file);

        let timestamp = Date.now();
        let codeValue = timestamp * 313;

        try {
            setIsUploading(true);
            const salt = await bcrypt.genSalt(10);
            const hash = await bcrypt.hash(codeValue.toString(), salt);

            const formData = new FormData();
            formData.append('image', file);
            formData.append('code', hash);

            const response = await axios.post('https://app.golet.app/golet/api/v1/website/front/plant-detect', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            navigate('/detection', { state: { plantData: response.data.plants } });
        } catch (error) {
            toast.error(error.response.data.error, { autoClose: 15000 });

        } finally {
            setIsUploading(false);
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        handleFileChange(event);
    };



    return (
        <div>
            <Navbar />

            <div className='container mt-24'>
                <img src={BGPlanet} alt='BG Img' className='img-bg-mobile' />
            </div>

            <div className="container mtn-top">
                <h2 className="text-center title">عکس گل و گیاهت رو بارگزاری کن و اسم و نحوه نگهداریش رو یادبگیر</h2>
            </div>

            <div className="d-flex align-items-center justify-content-space-around width-auto res-web">
                <div className="container container-shadow mt-24 d-flex flex-direction-coulmn align-items-center"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                >

{!isUploading && (
                        <>
                            <input 
                                type="file" 
                                ref={fileInputRef} 
                                onChange={handleFileChange} 
                                className="file-input" 
                                hidden 
                            />
                            <button className="btn-submit" onClick={handleButtonClick}>بارگزاری تصویر</button>

                            <div className="sub-text mt-8">یا عکس را بکشید و در اینجا رها کنید</div>

                            <div className="info-pics d-flex justify-content-center align-items-center">
                                <img src={Info} alt='Info Img' className='ml-8' />
                                راهنمای عکاسی
                            </div>
                        </>
                    )}
                    {isUploading && <div className="loading">در حال بارگذاری...</div>}
                        </div>

                    <div>
                        <img src={BGPlanet} alt='BG Img' className='img-bg-plant' />
                    </div>
                </div>

                <div className="d-flex justify-content-center align-items-center footer fw-600">
                    <img src={Fire} alt='Fire Img' className='ml-4' />
                    تشخیص +50 گل و گیاه آپارتمانی با کمک هوش مصنوعی
                </div>
            </div>
            );
}

            export default Home;
